import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";
import { SERVICE_META } from "@/lib/constants";
import { useAiSettings } from "@/hooks/useAiSettings";

export function SmartIntake({ onResult }) {
  const { on } = useAiSettings();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [res, setRes] = useState(null);
  const run = async () => {
    if (text.trim().length < 8) return toast.error("Tulis permintaan minimal satu kalimat");
    setBusy(true);
    try { const { data } = await api.post("/ai/intake", { text }); setRes(data); onResult(data); toast.success(`AI mengisi form: ${SERVICE_META[data.service_type]?.title || data.service_type} — silakan tinjau sebelum kirim`); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  if (!on("intake")) return null;
  return (
    <div className="rounded-lg border border-pink-500/40 bg-pink-500/5 p-3" data-testid="smart-intake">
      <div className="mb-1 flex items-center gap-1.5 text-xs font-semibold text-pink-600"><Sparkles className="h-3.5 w-3.5" />Smart Intake — tulis permintaan Anda, AI yang mengisi form</div>
      <Textarea rows={2} value={text} onChange={(e) => setText(e.target.value)} placeholder='Contoh: "butuh 5 rim kertas A4 dan 2 toner HP untuk bulan ini" atau "AC ruang kelas 2 bocor, tolong diperbaiki besok pagi"' className="bg-background text-sm" data-testid="smart-intake-text" onKeyDown={(e) => { if (e.key === "Enter" && (e.ctrlKey || e.metaKey)) run(); }} />
      <div className="mt-2 flex flex-wrap items-center gap-2">
        <Button type="button" size="sm" disabled={busy} onClick={run} className="bg-pink-600 hover:bg-pink-700" data-testid="smart-intake-btn">{busy ? <Loader2 className="mr-1 h-4 w-4 animate-spin" /> : <Sparkles className="mr-1 h-4 w-4" />}{busy ? "Menganalisis…" : "Isi Otomatis"}</Button>
        {res && <span className="text-[11px] text-muted-foreground" data-testid="smart-intake-notes">Keyakinan {Math.round((res.confidence || 0) * 100)}%{res.notes ? ` · ${res.notes}` : ""}</span>}
      </div>
    </div>
  );
}
